{
  "dataFieldsInTooltip": {
    "title": "Hover-Label für Objekte",
    "tooltip": "Wählen Sie bis zu 5 Attributwerte aus, die angezeigt werden sollen, wenn Sie den Mauszeiger über ein Kartenobjekt bewegen.",
    "tooltipAttributeTypes": "Unterstützte Attributtypen sind: Text, Zahl, Liste und What3Words",
    "error": "Etwas ist schief gelaufen. Bitte wenden Sie sich an den Support, wenn das Problem weiterhin besteht"
  },
  "tooltipShortcuts": {
    "select_object": "Drücken Sie V",
    "draw": "Drücken Sie D",
    "measure": "Drücken Sie M",
    "undo": "Strg + Z",
    "redo": "Strg + Shift + Z",
    "comment": "Drücken Sie C",
    "copy_paste": "Strg + C/Strg + V",
    "delete_object": "Drücken Sie Del",
    "cancel_drawing": "Drücken Sie Esc oder Rechtsklick",
    "confirm_drawing": "Drücken Sie die Eingabetaste oder doppelklicken Sie"
  },
  "draw": {
    "polygon": "Polygon",
    "line": "Linie",
    "rectangle": "Rechteck",
    "routePlanner": "Routenplaner",
    "point": "Punkt",
    "model": "Modell",
    "icon": "Ikone"
  },
  "select": {
    "select_object": "Objekt wählen",
    "select_area": "Wählen Sie Objekte innerhalb des Bereichs aus"
  },
  "drawRoute": "Route zeichnen",
  "drawLineRectangle": "Linie, Rechteck zeichnen",
  "layerOptionsTooltips": {
    "lock_layer": "Ebene sperren",
    "unlock_layer": "Ebene entsperren",
    "cannot_lock_layer_while_editing": "Sie können eine Ebene nicht sperren, während Sie sie bearbeiten"
  },
  "sitemapVersion": {
    "perimeter": "Umfang",
    "drawOutsideCADPerimeter": "Auf dieser Ebene kann nicht außerhalb der Grenze gezeichnet werden"
  },
  "map_objects": "Objekte zuordnen",
  "map_object": "Kartenobjekt",
  "plan": "Planen",
  "map_layer": "Kartenebenen",
  "layers": "Schichten",
  "layer": "Schicht",
  "layer_data_field": "Layer-Datenfeld",
  "layer_geoJson": "Ebene als GeoJSON",
  "route_waypoints": "Routen-Wegpunkte",
  "map_objects_attribute_values": "Kartenobjekte, Attributwerte",
  "saved_map_view": "gespeicherte Kartenansicht",
  "map_object_geometry": "Geometrie des Kartenobjekts",
  "map_background": "Hintergrund der Karte",
  "map_sidebar_order": "Reihenfolge der Karten-Seitenleiste",
  "map_comment": "Kommentar zur Karte",
  "model": "Modell",
  "snapping": {
    "snapToDraw": "Am Objekt ausrichten"
  },
  "drawMapObjectTooltip": "Klicken Sie, um dieser Ebene ein weiteres Objekt hinzuzufügen",
  "exports2": {
    "title": "Titel",
    "imageUpload": {
      "title": "Benutzerdefiniertes Logo"
    }
  },
  "digitalTwin": {
    "occupiedTable": {
      "id": "Server-ID",
      "status": "Status",
      "user": "Nutzer"
    },
    "status": {
      "Occupied": "Wird verwendet",
      "Available": "Verfügbar",
      "Starting": "Beginnt",
      "Stopped": "Gestoppt",
      "Error": "Fehler"
    },
    "occupiedPopup": {
      "header": "Alle Digital-Twin-Server sind derzeit nicht verfügbar",
      "message": "Bitte versuchen Sie es später erneut oder kontaktieren Sie {{ supportEmail }} für weitere Informationen"
    }
  },
  "fileUpload": {
    "invalid_compression_size": "Die Datei, die Sie hochladen möchten, ist zu groß und konnte nicht komprimiert werden."
  }
}